import workProgress from "@/api/work-progress";

export default {
  state: {},
  mutations: {},
  actions: {
    async retrieveWorkProgress(context) {
      try {
        let params = {
          management_id: await context.dispatch("showManagementID"),
          account_id: await context.dispatch("showAccountID"),
        }
        const response = await workProgress.index(params);
        if (response.data && response.data.data) {
          return response.data.data;
        }
        else {
          return [];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
